import { isOwnSelectableUnit } from "#/game/selection/transitions";
import type { StoreState } from "#/game/store/types";

function idleBoardGuards(state: StoreState): boolean {
  return (
    !state.animation &&
    !state.isSubmitting &&
    !state.aiPlayback &&
    state.localState.currentPlayer === "p1" &&
    state.localState.status === "in_progress"
  );
}

export function canEndTurnFromState(state: StoreState): boolean {
  return (
    idleBoardGuards(state) &&
    state.selection.mode !== "confirm-attack" &&
    state.selection.mode !== "confirm-capture-reset"
  );
}

export function hasUnactedOwnUnitsFromState(state: StoreState): boolean {
  if (state.localState.currentPlayer !== "p1") return false;
  return state.localState.units.some((unit) => isOwnSelectableUnit(state.localState, unit));
}

export function unactedOwnUnitIdsFromState(state: StoreState): string[] {
  if (state.localState.currentPlayer !== "p1") return [];
  return state.localState.units
    .filter((unit) => isOwnSelectableUnit(state.localState, unit))
    .map((unit) => unit.id);
}

export function canUndoPendingMovesFromState(state: StoreState): boolean {
  return idleBoardGuards(state) && state.pendingMoves.length > 0;
}

export function canUndoCommittedTurnFromState(state: StoreState): boolean {
  return (
    idleBoardGuards(state) &&
    state.pendingMoves.length === 0 &&
    state.localState.currentDay > 1 &&
    state.runVersion === 2
  );
}

export function canUndoFromState(state: StoreState): boolean {
  return canUndoPendingMovesFromState(state) || canUndoCommittedTurnFromState(state);
}
